import {BOT_CONV_MESSAGE_TYPE} from '../../../../helpers/consts/common-consts';
import dayjs from 'dayjs';
import {useAppInfo} from "../../../../helpers/hooks/common-hook";
import AuthConfig from "../../../../pages/auth-action/auth-config";
import AuthInit from "../../../../pages/auth-action/auth-init";
import {WEB_CHANNEL} from "../../../../consts/common-consts";

export default function AuthLoginMessage({sessionId, senderType, message}) {
    const { authConnector } = message;
    const { appId, accessKey } = useAppInfo();

  let theme =
    senderType === BOT_CONV_MESSAGE_TYPE
      ? 'conv-text-message-bot'
      : 'conv-text-message-user';
  return (
    <div className={`mt-2 flex flex-col rounded-xl ${theme} p-2 max-w-xs`}>
        <AuthConfig
                    authConnector={authConnector}
                    sessionId={sessionId}
                    channel={WEB_CHANNEL}
        ><AuthInit /></AuthConfig>
      <small className='px-1 text-xs text-gray-300 block'>
        {dayjs().format("hh:mm")}
      </small>
    </div>
  );
}
